import getLogger from '../util/logger';
import { getErrorString } from '../util/normalize-errors';
import { PURCHASE_TYPE } from '../components/global/ThankYouView/constants';
import { openModal } from './modal-actions';
import { THANK_YOU_MODAL } from '../components/global/ThankYouView';

const log = getLogger('DiscoverAlbumFolderAction');

export const SET_ALBUM_FOLDER = 'discover-album-folder/SET_ALBUM_FOLDER';
export const SELECT_IDENTITY = 'discover-album-folder/SELECT_IDENTITY';
export const DESELECT_IDENTITY = 'discover-album-folder/DESELECT_IDENTITY';
export const RESET_IDENTITY = 'discover-album-folder/RESET_IDENTITY';
export const SELECT_ALBUM = 'discover-album-folder/SELECT_ALBUM';
export const DESELECT_ALBUM = 'discover-album-folder/DESELECT_ALBUM';
export const SELECT_CUSTOM_PRINT = 'discover-album-folder/SELECT_CUSTOM_PRINT';
export const DESELECT_CUSTOM_PRINT =
  'discover/album-folder/DESELECT_CUSTOM_PRINT';
export const JOIN_ALBUMS_REQUEST = 'discover-album-folder/JOIN_ALBUMS_REQUEST';
export const JOIN_ALBUMS_SUCCESS = 'discover-album-folder/JOIN_ALBUMS_SUCCESS';
export const JOIN_ALBUMS_FAILURE = 'discover-album-folder/JOIN_ALBUMS_FAILURE';
export const PURCHASE_ALBUMS_REQUEST =
  'discover-album-folder/PURCHASE_ALBUMS_REQUEST';
export const PURCHASE_ALBUMS_SUCCESS =
  'discover-album-folder/PURCHASE_ALBUMS_SUCCESS';
export const PURCHASE_ALBUMS_FAILURE =
  'discover-album-folder/PURCHASE_ALBUMS_FAILURE';
export const CHECKOUT_REQUEST = 'discover-album-folder/CHECKOUT_REQUEST';
export const CHECKOUT_SUCCESS = 'discover-album-folder/CHECKOUT_SUCCESS';
export const CHECKOUT_FAILURE = 'discover-album-folder/CHECKOUT_FAILURE';
export const RESET_ALBUM_DISCOVERY =
  'discover-album-folder/RESET_ALBUM_DISCOVERY';
export const SET_JOIN_TYPE_DEFAULT =
  'discover-album-folder/SET_JOIN_TYPE_DEFAULT';
export const SET_JOIN_TYPE_SELECTION_FLAG =
  'discover-album-folder/SET_JOIN_TYPE_SELECTION_FLAG';
export const SET_DISCOVERY_PRESELECTION_VISIBILITY =
  'discover-album-folder/SET_DISCOVERY_PRESELECTION_VISIBILITY';
export const SET_IS_PLIC_CHECKOUT_FLAG =
  'discover-album-folder/SET_IS_PLIC_CHECKOUT_FLAG';
export const SET_FOUND_ROSTER_IDENTITIES =
  'discover-album-folder/SET_FOUND_ROSTER_IDENTITIES';
export const SET_SELECTED_ROSTER_IDENTITIES =
  'discover-album-folder/SET_SELECTED_ROSTER_IDENTITIES';
export const RESET_ROSTER_IDENTITIES =
  'discover-album-folder/RESET_ROSTER_IDENTITIES';
export const RESET_FOUND_ROSTER_IDENTITIES =
  'discover-album-folder/RESET_FOUND_ROSTER_IDENTITIES';
export const ADD_SELECTED_ROSTER_IDENTITY =
  'discover-album-folder/ADD_SELECTED_ROSTER_IDENTITY';
export const REMOVE_SELECTED_ROSTER_IDENTITY =
  'discover-album-folder/REMOVE_SELECTED_ROSTER_IDENTITY';

const setAlbumFolder = albumFolderId => {
  return { type: SET_ALBUM_FOLDER, albumFolderId };
};

const selectIdentity = (identity, joinType) => {
  return { type: SELECT_IDENTITY, identity, joinType };
};

const deselectIdentity = identity => {
  return { type: DESELECT_IDENTITY, identity };
};

const resetIdentity = () => {
  return { type: RESET_IDENTITY };
};

const selectAlbum = album => {
  return { type: SELECT_ALBUM, album };
};

const deselectAlbum = (album, identityId = null) => {
  return { type: DESELECT_ALBUM, album, identityId };
};

const selectCustomPrint = (albumCustomPrint, identityId = null) => {
  return { type: SELECT_CUSTOM_PRINT, albumCustomPrint, identityId };
};

const deselectCustomPrint = (albumCustomPrint, identityId = null) => {
  return { type: DESELECT_CUSTOM_PRINT, albumCustomPrint, identityId };
};

const checkoutAlbumsRequest = () => {
  return { type: JOIN_ALBUMS_REQUEST };
};

const checkoutAlbumsSuccess = payload => {
  return { type: JOIN_ALBUMS_SUCCESS, payload };
};

const checkoutAlbumsFailure = error => {
  return { type: JOIN_ALBUMS_FAILURE, error };
};

const checkoutRequest = () => {
  return { type: CHECKOUT_REQUEST };
};

const checkoutSuccess = payload => {
  return { type: CHECKOUT_SUCCESS, payload };
};

const checkoutFailure = error => {
  return { type: CHECKOUT_FAILURE, error };
};

export const resetAlbumDiscovery = () => {
  return { type: RESET_ALBUM_DISCOVERY };
};

export const setJoinTypeDefault = joinType => {
  return { type: SET_JOIN_TYPE_DEFAULT, joinType };
};

export const setJoinTypeSelectionFlag = flag => {
  return { type: SET_JOIN_TYPE_SELECTION_FLAG, flag };
};

export const setJoinTypePreselectionVisibility = flag => {
  return { type: SET_DISCOVERY_PRESELECTION_VISIBILITY, flag };
};

export const setIsPlicCheckoutFlag = flag => {
  log.info('setIsPlicCheckoutFlag() :: Flag:', flag);

  return { type: SET_IS_PLIC_CHECKOUT_FLAG, flag };
};

export const setFoundRosterIdentities = rosterIdentities => {
  log.info(
    'setFoundRosterIdentities() :: Roster identities:',
    rosterIdentities,
  );

  return { type: SET_FOUND_ROSTER_IDENTITIES, rosterIdentities };
};

export const setSelectedRosterIdentities = rosterIdentities => {
  log.info(
    'setSelectedRosterIdentities() :: Roster identities:',
    rosterIdentities,
  );

  return { type: SET_SELECTED_ROSTER_IDENTITIES, rosterIdentities };
};

export const resetRosterIdentities = () => {
  log.info('resetRosterIdentities() :: Resetting roster identities...');

  return { type: RESET_ROSTER_IDENTITIES };
};

export const resetFoundRosterIdentities = () => {
  log.info(
    'resetFoundRosterIdentities() :: Resetting found roster identities...',
  );

  return { type: RESET_FOUND_ROSTER_IDENTITIES };
};

export const addSelectedRosterIdentity = rosterIdentity => {
  log.info('addSelectedRosterIdentity() :: Roster identity:', rosterIdentity);

  return { type: ADD_SELECTED_ROSTER_IDENTITY, rosterIdentity };
};

export const removeSelectedRosterIdentity = rosterIdentity => {
  log.info(
    'removeSelectedRosterIdentity() :: Roster identity:',
    rosterIdentity,
  );

  return { type: REMOVE_SELECTED_ROSTER_IDENTITY, rosterIdentity };
};

export const onSetAlbumFolder = albumFolderId => dispatch => {
  log.info('onSetAlbumFolder() :: Album folder:', albumFolderId);

  dispatch(setAlbumFolder(albumFolderId));
};

export const onSelectIdentity = (identity, joinType) => dispatch => {
  log.info('onSelectIdentity() :: Selected identity:', identity, joinType);

  dispatch(selectIdentity(identity, joinType));
};

export const onDeselectIdentity = identity => dispatch => {
  log.info('onDeselectIdentity() :: Deselected identity:', identity);

  dispatch(deselectIdentity(identity));
};

export const onResetIdentity = () => dispatch => {
  log.info('onResetIdentity() :: Resetting identity...');

  dispatch(resetIdentity());
};

export const onSelectAlbum = album => dispatch => {
  log.info('onSelectAlbum() :: Selected album:', album);

  dispatch(selectAlbum(album));
};

export const onDeselectAlbum =
  (album, identityId = null) =>
  dispatch => {
    log.info(
      'onDeselectAlbum() :: Deselected album:',
      album,
      'Identity:',
      identityId,
    );

    dispatch(deselectAlbum(album, identityId));
  };

export const onSelectAlbumCustomPrint =
  (albumCustomPrint, identityId = null) =>
  dispatch => {
    log.info(
      'onSelectAlbumCustomPrint() :: Selected custom print:',
      albumCustomPrint,
      'Identity:',
      identityId,
    );

    dispatch(selectCustomPrint(albumCustomPrint, identityId));
  };

export const onDeselectAlbumCustomPrint =
  (albumCustomPrint, identityId = null) =>
  dispatch => {
    log.info(
      'onDeselectAlbumCustomPrint() :: Deselected custom print:',
      albumCustomPrint,
      'Identity:',
      identityId,
    );

    dispatch(deselectCustomPrint(albumCustomPrint, identityId));
  };

/**
 * Checks out albums, either purchasing or joining them.
 *
 * @param {Object} options - The method's options.
 * @param {string} options.accountId - The account id.
 * @param {string} options.accountAddressId - The account address id.
 * @param {string} [options.email] - The account email, usually provided by Stripe.
 * @param {string} [options.stripeToken] - Stripe's token - required if purchasing.
 * @param {string} [options.stripePaymentMethodId] - Stripe's payment method ID
 * @param {string} [options.stripeConnectAccountId] - Stripe connect account ID
 * @param {Array<Object>} options.purchaseItems - The items to purchase.
 * @param {Array<Object>} options.joinItems - The items to join.
 * @param {Function} [options.checkoutMutation] - The checkout mutation.
 * @param {Function} [options.albumsJoinByCodeMutation] - The albumsJoinByCode mutation.
 * @param {String} [options.promoCode] - The promoCode to use if available
 * @returns {Function} - The thunk promise.
 */
export const checkoutAlbums =
  ({
    accountId,
    accountAddressId,
    email,
    stripeToken,
    purchaseItems,
    joinItems,
    checkoutMutation,
    albumsJoinByCodeMutation,
    stripePaymentMethodId,
    stripeConnectAccountId,
    promoCode,
  }) =>
  async dispatch => {
    log.info(
      'checkoutAlbums() :: Purchasing/Joining albums...',
      purchaseItems,
      joinItems,
    );

    dispatch(checkoutAlbumsRequest());

    try {
      let response = {};

      const {
        ppaItems = [],
        photoItems = [],
        photoPrintItems = [],
        customPrintItems = [],
        searchSubscriptionItems = [],
        digitalBundleItems = [],
      } = purchaseItems;

      if (
        ppaItems.length > 0 ||
        photoItems.length > 0 ||
        photoPrintItems.length > 0 ||
        customPrintItems.length > 0 ||
        digitalBundleItems.length > 0 ||
        searchSubscriptionItems.length > 0
      ) {
        response = await checkoutMutation({
          accountId,
          accountAddressId,
          email,
          stripeToken,
          ppaItems,
          photoItems,
          photoPrintItems,
          customPrintItems,
          digitalBundleItems,
          searchSubscriptionItems,
          stripePaymentMethodId,
          stripeConnectAccountId,
          promoCode,
        });

        // Return early if there's an error in purchasing
        if (!response.data.checkout.is_paid) {
          const errorMessage = response.data.checkout.errors.join('. ');

          dispatch(checkoutAlbumsFailure(getErrorString(errorMessage)));

          log.error('checkoutAlbums() :: Error:', errorMessage);
          return;
        }
      }

      if (joinItems && joinItems.length > 0) {
        for (const joinItem of joinItems) {
          await albumsJoinByCodeMutation(accountId, joinItem.join_codes, [
            joinItem.identity_id,
          ]);
        }
      }

      log.info('checkoutAlbums() :: Checkout success');
      dispatch(checkoutAlbumsSuccess(response?.data?.checkout));
    } catch (error) {
      log.error('checkoutAlbums() :: Error:', error);

      dispatch(checkoutAlbumsFailure(getErrorString(error)));
    }
  };

/**
 * Performs the job of both purchasing & joining an album folder
 * depending on user selection.
 *
 * @param {Object} params The action params.
 * @param {String} params.accountId The account joining/purchasing.
 * @param {String} params.accountAddressId The account address id
 * @param {String} params.albumFolderId The  albumFolderId.
 * @param {String} [params.email] Email which was used to join/purchase.
 * @param {String} [params.stripeToken] Stripe token.
 * @param {string} [params.stripePaymentMethodId] - Stripe's payment method ID
 * @param {string} [params.stripeConnectAccountId] - Stripe connect account ID
 * @param {Object} [params.purchaseItems] Checkout items.
 * @param {Array<String>} params.identityIdsToJoin Identity IDs that will only be joined to the album folder.
 * @param {string} params.albumFolderJoinCode Join Code for the album folder. Required for join.
 * @param {Function} params.checkoutMutation The checkout mutation.
 * @param {Function} params.joinByCodeMutation The join by code mutation.
 * @param {Function} params.albumFolderJoinMutation The join by code mutation.
 * @param {Function} params.refetchAccountQuery The refetch account query

 */
export const checkoutAlbumFolder =
  ({
    accountId,
    accountAddressId,
    email,
    stripeToken,
    purchaseItems,
    identityIdsToJoin,
    albumFolderJoinCode,
    albumFolderId,
    checkoutMutation,
    joinByCodeMutation,
    albumFolderJoinMutation,
    refetchAccountQuery,
    stripePaymentMethodId,
    stripeConnectAccountId,
  }) =>
  async dispatch => {
    log.info(
      'checkoutAlbumFolder() :: Purchasing Album Folder....',
      purchaseItems,
    );
    log.info(
      'checkoutAlbumFolder() :: Joining Album Folder...',
      identityIdsToJoin,
    );

    dispatch(checkoutRequest());

    const hasJoinItems = identityIdsToJoin.length > 0;
    let checkoutRes;
    try {
      const {
        ppaItems = [],
        photoItems = [],
        photoPrintItems = [],
        customPrintItems = [],
        searchSubscriptionItems = [],
        digitalBundleItems = [],
        promoCode = '',
      } = purchaseItems;

      if (
        ppaItems.length > 0 ||
        photoItems.length > 0 ||
        photoPrintItems.length > 0 ||
        customPrintItems.length > 0 ||
        searchSubscriptionItems.length > 0 ||
        digitalBundleItems.length > 0
      ) {
        checkoutRes = await checkoutMutation({
          accountId,
          accountAddressId,
          email,
          stripeToken,
          ppaItems,
          photoItems,
          photoPrintItems,
          customPrintItems,
          searchSubscriptionItems,
          digitalBundleItems,
          promoCode,
          stripePaymentMethodId,
          stripeConnectAccountId,
        });

        if (searchSubscriptionItems.length > 0 && refetchAccountQuery) {
          await refetchAccountQuery();
        }

        if (checkoutRes.data.checkout.is_paid) {
          log.info('checkoutAlbumFolder() :: Checkout success');

          if (searchSubscriptionItems.length > 0) {
            const [searchSubscriptionItem] = searchSubscriptionItems;
            const purchaseMetadata = {
              subscriptionDetails: {
                searchSubscriptionItem,
                freeTrialAvailable: searchSubscriptionItem.trial_days > 0,
              },
              verticalDetails: {
                persona: undefined,
                basename: 'consumer',
              },
            };

            dispatch(
              openModal(THANK_YOU_MODAL, {
                purchaseType: PURCHASE_TYPE.SEARCH_SUBSCRIPTION,
                purchaseMetadata,
              }),
            );
          }

          if (!hasJoinItems) {
            dispatch(checkoutSuccess(checkoutRes.data.checkout));
          }
        } else {
          const errorMessage = checkoutRes.data.checkout.errors.join('. ');

          dispatch(
            checkoutFailure({
              message: errorMessage,
            }),
          );

          log.error('checkoutAlbumFolder() :: Error:', errorMessage);
          return;
        }
      }

      if (hasJoinItems) {
        if (albumFolderJoinCode) {
          await joinByCodeMutation(
            accountId,
            albumFolderJoinCode,
            identityIdsToJoin,
            true,
          );
        } else {
          await albumFolderJoinMutation({
            albumFolderId,
            identities: identityIdsToJoin,
          });
        }
      }

      log.info('checkoutAlbumFolder() :: Join success');

      dispatch(checkoutSuccess(checkoutRes?.data?.checkout));
    } catch (error) {
      log.error('checkoutAlbumFolder() :: Error:', error);

      dispatch(checkoutFailure(getErrorString(error)));
    }
  };
